module.exports = __webpack_public_path__ + "img/peremena.948dfc60.gif";